<template>
    <div>

      <section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Data Kelurahan/Desa</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th class="text-center" style="width: 10%">Kode Kelurahan</th>
                            <th class="text-center" style="width: 25%">Kel/Desa</th>
                            <th class="text-center" style="width: 10%">Kode Sektor</th>
                            <th class="text-center" style="width: 10%">KodePos</th>
                            <th class="text-center" style="width: 25%">Kecamatan</th>
                            <th class="text-center" style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr class="h_isitable" v-for="(data, index) in list_data" :key="data._id">
                            <td class="text-center">{{index+1}}.</td>
                            <td class="text-center">{{data.kd_kelurahan}}</td>
                            <td>{{data.nm_kelurahan}}</td>
                            <td class="text-center">{{data.kd_sektor}}</td>
                            <td class="text-center">{{data.kd_pos_kelurahan}}</td>
                            <td>{{data.nm_kecamatan}}</td>
                            <td class="text-center" >
                              <button @click="getView(data.id)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                  <i class="material-icons" >create</i>
                              </button>
&nbsp;
                              <button @click="removeData(data.id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                  <i class="material-icons" >clear</i>
                              </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>
                        &nbsp;
                      <span style="font-size: 85%; color: #a5a5a5"><b>&nbsp; {{page_first}} - {{page_last}} &nbsp;</b></span>
                        &nbsp;
                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    
                        <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-blue">
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>
                                    <div class="modal-body">

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Nama Kecamatan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                            <div class="form-line">
                                                <autocomplete
                                                :url="URL+ 'api/v1/bhumie_kecamatan/autocomplete'"
                                                :customHeaders="{authorization: 'kikensbatara '+token }"
                                                anchor="nm_kecamatan"
                                                :initValue="nm_kecamatan"
                                                :classes="{ input: 'form-control'}"
                                                label="writer"
                                                :onShouldRenderChild="renderChild"
                                                :on-select="getAuto">
                                                </autocomplete>
                                            </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Nama Kelurahan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="nm_kelurahan" type="text" class="form-control" placeholder="Ex : Baruga">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Kode Sektor</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="kd_sektor" type="text" class="form-control" placeholder="Ex : Baruga">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Kode Kelurahan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="kd_kelurahan" type="text" class="form-control" placeholder="Ex : Baruga">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Nomor Kelurahan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="no_kelurahan" type="text" class="form-control" placeholder="Ex : Baruga">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">KodePos Kelurahan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="kd_pos_kelurahan" type="text" class="form-control" placeholder="Ex : Baruga">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        
                        <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button @click="exit_modal" type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                    </div>
                                    <div class="modal-body">

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Nama Kecamatan</label>
                                        </div>
                                        <div class="col-md-10" v-if="edit_data">
                                            <div class="form-group">
                                            <div class="form-line">
                                                <autocomplete
                                                :url="URL+ 'api/v1/bhumie_kecamatan/autocomplete'"
                                                :customHeaders="{authorization: 'kikensbatara '+token }"
                                                anchor="nm_dati2"
                                                :initValue="nm_kecamatan"
                                                :classes="{ input: 'form-control'}"
                                                label="writer"
                                                :onShouldRenderChild="renderChild"
                                                :on-select="getAuto">
                                                </autocomplete>
                                            </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Nama Kelurahan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="nm_kelurahan" type="text" class="form-control" placeholder="Ex : Baruga">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Kode Sektor</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="kd_sektor" type="text" class="form-control" placeholder="Ex : Baruga">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Kode Kelurahan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="kd_kelurahan" type="text" class="form-control" placeholder="Ex : Baruga">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Nomor Kelurahan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="no_kelurahan" type="text" class="form-control" placeholder="Ex : Baruga">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">KodePos Kelurahan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="kd_pos_kelurahan" type="text" class="form-control" placeholder="Ex : Baruga">
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    </div>
                                    <div class="modal-footer">
                                        <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                                        <button @click="exit_modal" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>



<script>
import Autocomplete from 'vue2-autocomplete-js'
const URL_SERVER = URL_APP;
const URL_DATI2 = URL_APP+'api/v1/bhumie_dati2/';
const ADD_URL = URL_APP+'api/v1/bhumie_kelurahan/';


export default {
  name: "bhumie_kecamatan",
  components: { Autocomplete },
  data() {
    return {
      id: "",
      nm_kecamatan: "",
      kd_kecamatan: "",
      nm_kelurahan: "",
      kd_kelurahan: "",
      no_kelurahan: "",
      kd_pos_kelurahan : "",
      kd_sektor: "",

      edit_data : false,
      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
      token : localStorage.token,
      URL : URL_SERVER


    };
  },

// =============================================================== METHODS =========================================================================
  methods : {
    getData : function(){
      fetch(ADD_URL+'view', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      }).then(res => res.json())
        .then((data_res) => {
          this.list_data = data_res.data;
          this.page_last = data_res.jml_data
          // console.log(this.list_data);
        })
    },

    addData : function(){
      fetch(ADD_URL+'add', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
            kd_kecamatan : this.kd_kecamatan,
            nm_kelurahan : this.nm_kelurahan,
            kd_kelurahan : this.kd_kelurahan,
            no_kelurahan : this.no_kelurahan,
            kd_pos_kelurahan : this.kd_pos_kelurahan,
            kd_sektor : this.kd_sektor,
        })
      }).then((res_data)=>{
        this.alertku("success", "sukses menambah data");
        this.getData();
      });
    },

    editData : function(){
      fetch(ADD_URL+'update', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+localStorage.token
        },
        body : JSON.stringify({
            id : this.id,
            kd_kecamatan : this.kd_kecamatan,
            nm_kelurahan : this.nm_kelurahan,
            kd_kelurahan : this.kd_kelurahan,
            no_kelurahan : this.no_kelurahan,
            kd_pos_kelurahan : this.kd_pos_kelurahan,
            kd_sektor : this.kd_sektor,
        })
      }).then((res_data)=>{
        this.alertku("success", "sukses mengubah data");
        this.getData();
      })
    },

    removeData : function(id){
      fetch(ADD_URL+"remove", {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token,
        },
        body : JSON.stringify({
          id : id,
        })
      }).then(()=>{
        this.alertku("success", "sukses menghapus data");
        this.getData();
      })
    },

    getView : function(id){
      fetch(ADD_URL+"getView", {
          method : "POST",
          headers : {
              'content-type' : 'application/json',
              authorization : "kikensbatara "+localStorage.token,
          },
          body : JSON.stringify({
              id : id
          })
      }).then(res => res.json())
      .then((res_data)=>{
        //   console.log(res_data);
            this.nm_kecamatan = res_data[0].nm_kecamatan;
            this.kd_kecamatan = res_data[0].kd_kecamatan;
            this.nm_kelurahan = res_data[0].nm_kelurahan;
            this.kd_kelurahan = res_data[0].kd_kelurahan;
            this.no_kelurahan = res_data[0].no_kelurahan;
            this.kd_pos_kelurahan = res_data[0].kd_pos_kelurahan;
            this.kd_sektor = res_data[0].kd_sektor;
            this.id = res_data[0].id;
            this.edit_data = true;
      })
    },

    exit_modal : function(){
      this.edit_data = false;
    },


// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getData();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getData();
    },

    cari_data: function() {
      this.getData();
    },
// ================== PAGINASI ====================

// ================== AUTOCOMPLETED ====================
    getAuto : function(obj){
      // console.log(obj);
      this.nm_kecamatan = obj.nm_kecamatan;
      this.kd_kecamatan = obj.kd_kecamatan;
    },
    renderChild(data) {
        return `
        <span><b>${data.nm_kecamatan}</b></span>
        <span style='font-size:80%'>${data.nm_dati2}</span>
        `
    },
// ================== AUTOCOMPLETED ====================

  },
// =============================================================== METHODS =========================================================================

  mounted() {
    this.getData();
    // this.autocompleted();
  },
};
</script>
